/**
 * JavaScript Graphical User Interface
 * Defining GUI.Ajax namespace
 *
 * @author S. [LinuZz] Ostapenko
 * @version 2.0
 * @namespace GUI
 */
GUI.Ajax = {};